import { WorkOrderStatusEnum } from '@ztechapps/common.contract'

/**
 * Work order statuses that take no more edits — Complete, Cancelled or Destructed. Shared by
 * `isWorkOrderLocked` and the logistics production picker filter so the "no more edits" set isn't
 * re-spelled per call site.
 *
 * Precedent: `libs/order/common/src/order/committedOrderStatuses.ts:8`.
 */
export const LOCKED_WORK_ORDER_STATUSES: WorkOrderStatusEnum[] = [
  WorkOrderStatusEnum.Complete,
  WorkOrderStatusEnum.Cancelled,
  WorkOrderStatusEnum.Destructed,
]
